import React from 'react'
import { ChevronDown } from 'lucide-react'

import { CSV_ENCODING_TYPE } from '../../type'
import type { CsvEncodingType } from '../../type'
import styles from './style.module.css'

const ENCODING_OPTIONS = [
  CSV_ENCODING_TYPE.ShiftJis,
  CSV_ENCODING_TYPE.Utf8,
  CSV_ENCODING_TYPE.Windows31j,
]

type Props = {
  value: CsvEncodingType
  onChange: (value: CsvEncodingType) => void
}

export const EncodingSelect: React.FC<Props> = ({ value, onChange }) => (
  <div className={styles.encodingRow}>
    <span className={styles.label}>文字コード</span>
    <div className={styles.selectField}>
      <select
        className={styles.encodingSelect}
        name="encoding-type"
        value={value}
        onChange={(e) => onChange(e.target.value as CsvEncodingType)}
      >
        {ENCODING_OPTIONS.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <ChevronDown className={styles.selectChevron} size={16} aria-hidden={true} />
    </div>
  </div>
)
